import Grid from "../../../../../components/dialogs/Grid";
import TextField from "../../../../../components/fields/textfield/TextField";
import {_transl} from "../../../../../store/localization/TranslMessasge";
import React from "react";
import {ConnectableConceptInfoDto} from "../../../../../common/apis/relationship/ConnectableConceptInfoDto";
import {ElementTranslationKey} from "../../elements/ElementTranslationKey";
import SectionHeader from "../../../../../components/SectionHeader";

export interface ConnectableConceptInfoPanelProps {
    title: string;
    connectableConcept: ConnectableConceptInfoDto;
}

export default function ConnectableConceptInfoPanel(props: Readonly<ConnectableConceptInfoPanelProps>) {
    const {title, connectableConcept} = props;

    return (
        <Grid container noStyle={true} spacing={2}>
            <Grid item xs={12}>
                <SectionHeader>{title}</SectionHeader>
            </Grid>
            <Grid item xs={12} sm={7}>
                <TextField label={_transl(ElementTranslationKey.NAME)}
                        value={connectableConcept.name ?? ""}
                        InputProps={{
                           readOnly: true,
                        }} />
            </Grid>
            <Grid item xs={12} sm={5}>
                <TextField label={_transl(ElementTranslationKey.GRID_HEADER_IDENTIFIER)}
                        value={connectableConcept.identifier ?? ""}
                        InputProps={{
                            readOnly: true,
                        }} />
            </Grid>
        </Grid>
    );
}